'use client';

import { FC } from 'react';
export interface PageBannerProps {
  title: React.ReactNode;
  description: string | JSX.Element;
  descriptionTwo: string | JSX.Element;
  backgroundColor?: 'green' | 'violet' | 'pink';
  customerInterfaceImage: React.ReactNode;
  backgroundImage: React.ReactNode;
  backgroundImageTwo: React.ReactNode;
  showNewTag: boolean;
}

const renderNewTagIfApplicable = (showNewTag: boolean) => {
  if (!showNewTag) {
    return null;
  }

  return (<div className="text-blue-900 uppercase text-14.5/22 bg-citron-500 rounded-[4px] p-[4px] font-500 mb-[18px] mt-[36px] md:mt-0">
    new
  </div>);
};

const PageBanner: FC<PageBannerProps> = ({
  title,
  description,
  descriptionTwo,
  customerInterfaceImage,
  backgroundColor = 'pink',
  backgroundImage,
  backgroundImageTwo,
  showNewTag = true,
}) => {
  return (
    <div className={`text-white bg-{$backgroundColor}-100`}>
      <div className="-mt-header-height-mobile md:-mt-header-height-desktop md:pt-header-height-desktop">
        <div className="pt-11 md:pt-12 px-container-mobile md:px-container-desktop pb-[200px]">
          <div className="grid gap-2 md:gap-3 text-left mx-auto max-w-grid">
            <div
              className={`flex flex-wrap md:flex-nowrap flex-col-reverse md:flex-row justify-left bg-${backgroundColor}-800 rounded-[16px] items-center`}
            >
              <div className="flex mt-[44px] w-full md:w-[45%] justify-end md:justify-start mr-[-5px] md:mr-0">
                {customerInterfaceImage}
              </div>
              <div className="flex w-full md:w-[55%] h-auto md:h-[100%] relative">
                <div className="flex flex-wrap w-full items-center">
                  <div className="flex flex-wrap mr-[20px] ml-[20px] md:ml-[68px] md:mr-0">
                    { renderNewTagIfApplicable(showNewTag)}
                    <h3 className="font-500 text-36/44 text-white mb-[9px] w-full">{title}</h3>
                    <div className="flex text-white text-17/25">
                      {description}
                      <br />
                      {descriptionTwo}
                    </div>
                  </div>
                </div>
                <div className="absolute bottom-0 left-[-4px] hidden md:block">{backgroundImage}</div>
                <div className="absolute top-0 right-0 hidden md:block">{backgroundImageTwo}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
